import React from "react";
import { MarginProps } from "styled-system";

import Box from "../Box";
import { CText } from "@carrefour/design-system-components-react";
import styled from "styled-components";
import { Dayjs } from "dayjs";

const Text = styled(CText)<{ color?: string; textAlign: string }>`
  color: ${(props) => props.color};
  font-family: system-ui;
  text-align: ${(props) => props.textAlign};
  width: 12px;
`;

type TimeScaleProps = {
  slots: Array<Dayjs>;
} & MarginProps;

const TimeScale = ({ slots, ...rest }: TimeScaleProps) => {
  return (
    <Box
      display="flex"
      flexDirection={"column"}
      alignItems="start"
      justifyContent="space-between"
      data-testid="timescale"
      // px={1}
      {...rest}
    >
      {slots.map((slot, index) => {
        // Si ce n'est pas le dernier élément, calculer la différence avec le suivant
        const nextDateTime = slots[index + 1];
        const diffMinutes = nextDateTime
          ? nextDateTime.diff(slot, "minute")
          : 60; // Par défaut 60 min si dernier élément

        const height = (diffMinutes / 30) * 40; // 40px par tranche de 30 min
        return (
          <Box height={height}>
            <Text
              key={slot.toISOString()}
              textAlign="center"
              bold
            >
              {slot.format("H:mm")}
            </Text>
          </Box>
        );
      })}
    </Box>
  );
};

export default TimeScale;
